import { EventTypes, track } from '@mc/track-event'
import { LOCATION_RELATED_COURSES } from 'components/GlobalCarousel/events'

export const trackRelatedCoursesCarouselViewed = () =>
  track(EventTypes.COURSE_MARKETING_PAGE_ROW_VIEWED, {
    category: 'explore-class-catalog',
    row_name: LOCATION_RELATED_COURSES,
  })
